export default {
  noExportSettings: 'None of the blocks of this report needs settings for the export.',
};
